import React, { useState } from 'react'
import { TextField, Button, Typography, Box, Container, Tooltip } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import http from '../../../utils/Http/Http'
import { createUser } from '../../../utils/Firebase/methods'
import { handleFirebaseAuthError } from '../../../utils/Firebase/errorHandler'
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip'

export const CreateAccountForm = () => {
	const [searchParams] = useSearchParams()
	const [firstName, setFirstName] = useState(searchParams.get('firstname'))
	const [lastName, setLastName] = useState(searchParams.get('lastname'))
	const [email, setEmail] = useState(searchParams.get('email'))
	const [password, setPassword] = useState('')
	const [error, setError] = useState('')

	const handleCreateAccount = async (e) => {
		e.preventDefault()
		setError('')
		try {
			const userCredential = await createUser({ email, password, firstName, lastName })
			// Prepare data to be sent to your API
			const postData = {
				firstName,
				lastName,
				email,
				user_id: userCredential.user.uid, // Include Firebase user ID
			}

			// POST request to your user service
			const response = await http({
				url: '/user',
				method: 'post',
				data: postData,
			})

			if (response.status !== 201) {
				throw new Error('Failed to create user on the server')
			}
		} catch (error) {
			const userFriendlyMessage = handleFirebaseAuthError(error)
			setError(userFriendlyMessage)
			console.error('Account creation failed:', error)
		}
	}

	return (
		<Container component="main" maxWidth="xs">
			<h2>Create a password to start your membership</h2>
			<Box component="form" onSubmit={handleCreateAccount} sx={{ mt: 1 }}>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="First Name"
					autoComplete="fname"
					autoFocus
					value={firstName}
					onChange={(e) => setFirstName(e.target.value)}
				/>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="Last Name"
					autoComplete="lname"
					value={lastName}
					onChange={(e) => setLastName(e.target.value)}
				/>
				<HtmlTooltip
					placement="right-start"
					title={
						<Typography color="error">
							We need you to use the same email address when registering. Don’t worry: you can change your
							email address after registration!
						</Typography>
					}
				>
					<TextField
						type="email"
						variant="outlined"
						margin="normal"
						required
						fullWidth
						label="Email Address"
						autoComplete="email"
						value={email}
						disabled={!!searchParams.get('email')}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</HtmlTooltip>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="Password"
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
				<Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
					Create Account
				</Button>
				{error && <Typography color="error">{error}</Typography>}
			</Box>
		</Container>
	)
}
